import { SwitchRow } from '@components'

import { ReactElement } from 'react'
import { useTranslation } from 'react-i18next'

import { useTrackInvoicingSettings } from '@features/invoicingSettings/hooks/useTrackInvoicingSettings'

import { useFormContext } from '../../../../../../../../../../../../hooks'
import { InvoiceSettingsFormSchema } from '../../../../../../types/invoiceSettingsFormSchema'

export const ShowTermsAndConditions = (): ReactElement => {
  const { t } = useTranslation()
  const { trackInvoicingSettings } = useTrackInvoicingSettings()
  const { FormItem } = useFormContext<InvoiceSettingsFormSchema>()

  return (
    <FormItem
      name="shouldShowTermsAndConditions"
      render={({ field: { onChange, value, ...props } }) => (
        <SwitchRow
          {...props}
          checked={value}
          label={t('settings.organization.external_invoice.content.show_terms_and_conditions.label')}
          onChange={(event) => {
            onChange(event)
            trackInvoicingSettings('Show terms and conditions', { checked: event.target.checked })
          }}
        />
      )}
    />
  )
}
